/* eslint-disable quotes */
/* eslint-disable semi */
import httpClient from '@/utils/http-client.js';
import { storeActions } from '@store/actions.constants';
import { storeMutations } from '@store/mutations.constants';

const userActions = {
  [storeActions.createDomain]: ({ commit }, payLoad) => {
    console.log(payLoad);
    return httpClient.post('/domain/add', payLoad).then(
      (res) => {
        console.log(res);

        commit(storeMutations.domainMutation, res);
        return res;
      },
      (err) => {
        commit(storeMutations.domainMutation, err);
        return err.response;
      },
    );
  },
  [storeActions.getDomain]: ({ commit }, payLoad) => {
    let url=`/domain/get?page=${payLoad.page}&limit=${payLoad.limit}`
    if(payLoad.sort) url+=`&sort={"${payLoad.sort}":"${payLoad.desc?-1:1}"}`
    if(payLoad.search)url+=`&search=${payLoad.search}`
    return httpClient
      .get(
        url,                                                                    
        payLoad,
      ).then(
        (res) => {
          commit(storeMutations.setDomainMutation, res);
          return res;
        },
        (err) => {
          commit(storeMutations.setDomainMutation, err);
          return err.response;
        },
      );
     
     
  },
  [storeActions.getDomainById]: ({ commit }, payLoad) => {
    console.log(payLoad.id);
    return httpClient.get('/domain/getById/' + payLoad.id).then(
      (res) => {
        console.log(res);

        commit(storeMutations.domainMutation, res);
        return res;
      },
      (err) => {
        commit(storeMutations.domainMutation, err);
        return err.response;
      },
    );
  },

  [storeActions.updateDomainById]: ({ commit }, payLoad) => {
    console.log(payLoad);
    return httpClient.post('/domain/update', payLoad).then(
      (res) => {
        console.log(res);

        // commit(storeMutations.domainMutation, res);
        return res;
      },
      (err) => {
        // commit(storeMutations.domainMutation, err);
        return err.response;
      },
    );
  },
};
export default { ...userActions };